import { useGameStore } from '../store/gameStore';

/**
 * CRT scanlines + vignette — only on the Pip-Boy (`terminal`) theme. The flat
 * themes (clay, carbon) deliberately render no overlay, matching their
 * modern-terminal reference look.
 */
export function CrtOverlay() {
  const theme = useGameStore((s) => s.theme);
  if (theme !== 'terminal') return null;
  return (
    <>
      <div className="fixed inset-0 pointer-events-none z-50 crt-scanlines" />
      <div className="fixed inset-0 pointer-events-none z-50 crt-vignette" />
    </>
  );
}
